module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("Getting Started")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03"
    }
  }, [_vm._v("Shape Up")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Head Over Heels")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let’s Face It")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mood Swings")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Body Building")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Know the Type")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Measuring Up")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lights, Camera, Action!")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Body Language")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dress ’Em Up")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Give ’Em Props")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You’ve Got Males!")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ladies’ Night")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kidding Around")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grow Up!")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forget Me Not")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opposites Attract")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s Alive!")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get Graphic")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Find Your Own Style")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f7044d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 60
// module chunks = 0